import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AbstractControl, FormControl, ValidatorFn, Validators } from '@angular/forms';

export interface ISplitRecordResult {
  shouldSplit: boolean;
  splitValue: number;
}

@Component({
  selector: 'app-modal-content-split-modal',
  templateUrl: './modal-content-split-modal.component.html',
  standalone: false,
})
export class ModalContentSplitModalComponent implements OnInit {
  @Input() public pool!: number;
  @Output() public readonly split = new EventEmitter<ISplitRecordResult>();

  public formCtrl = new FormControl([Validators.required, Validators.min(0), this.greaterThanOrEqualValidator()]);

  public ngOnInit(): void {
    if (this.pool === undefined) throw new Error('You must supply variable "pool" to the data object for this modal.');
    this.formCtrl.markAsTouched(); //makes the validation issues appear immediately
  }

  public handlePromptClicked(shouldSplit: boolean) {
    if (Number(this.formCtrl.value) >= 0) {
      this.split.emit({
        shouldSplit,
        splitValue: Number(this.formCtrl.value ?? 0),
      });
    } else {
      this.split.emit({
        shouldSplit: false,
        splitValue: 0,
      });
    }
  }

  private greaterThanOrEqualValidator(): ValidatorFn {
    return (control: AbstractControl) => {
      const isGreaterThanOrEqualTo = Number(control.value) >= this.pool;
      return isGreaterThanOrEqualTo ? { greaterThanOrEqualTo: { value: control.value } } : null;
    };
  }
}
